import { requestAndParse, requestSuccessful } from '../request';

const anonymizeUser = async (userId: number) => {
    const route = 'admin/anonymize-user';
    const payload = { userId };

    const response = await requestAndParse(route, payload);

    const success = requestSuccessful(response);
    const message = response.body?.message as string;

    return { success, message };
};

export default anonymizeUser;
